import { type FC } from "react";

import { clsx } from "clsx";

import { faFile } from "@fortawesome/pro-duotone-svg-icons/faFile";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const EmptyPlaceholder: FC<{
  title: string;
  text: string;
  disabled?: boolean;
}> = ({ title, text, disabled = false }) => (
  <div
    className={clsx(
      "flex flex-col items-center justify-center gap-1 py-5 text-center",
      disabled ? "text-slate-300" : "text-slate-400",
    )}
  >
    <FontAwesomeIcon icon={faFile} className="mb-1.5 text-xl" />
    <span
      className={clsx(
        "text-sm font-medium",
        disabled ? "text-slate-400" : "text-slate-500",
      )}
    >
      {title}
    </span>
    <span className="text-sm">{text}</span>
  </div>
);
